import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { TCombinedCustomField } from 'src/app/project/modules/custom-fields/combine-custom-fields/combined-custom-field.model';
import { TShare } from 'src/app/project/modules/share/share.model';

@Component({
  selector: 'pp-user-management-site-row',
  templateUrl: './user-management-site-row.component.html',
  styleUrls: ['./user-management-site-row.component.scss'],
  standalone: false,
})
export class UserManagementSiteRowComponent implements OnDestroy {
  @Input() ppShare: TShare;
  @Input() ppIndex: number;
  @Input() ppCustomFields: TCombinedCustomField[];
  @Input() ppLast: boolean;
  @Output() ppNavigate = new EventEmitter<string>();

  relatedPointsFlagEnabled: boolean;
  private readonly destroy$ = new Subject<void>();

  constructor(private featureFlagService: FeatureFlagService) {
    this.relatedPointsFlagEnabled = this.featureFlagService.getFlag(EFeatureFlag.RELATED_POINTS);

    this.featureFlagService.flagsChange$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.relatedPointsFlagEnabled = this.featureFlagService.getFlag(EFeatureFlag.RELATED_POINTS);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  emitNavigateToSite(workspaceId: string): void {
    this.ppNavigate.emit(workspaceId);
  }
}
